import { useIsNavigatingAway } from '@jane/bloom/hooks/navigation/useIsNavigatingAway';
import { usePinStore } from '@jane/bloom/hooks/storeSwitcher/usePinStore';
import type {
  CommunicationBannerViewModel,
  ImageBannerViewModel,
  TextBannerViewModel,
} from '@jane/bloom/viewModels/communicationBanner';

import { ImageBanner } from './communicationBanner/imageBanner';
import { TextBanner } from './communicationBanner/textBanner';
import { CarouselSkeleton } from './skeletonLoaders/carouselSkeleton';

function isTextCommunicationBanner(
  communicationBanner: CommunicationBannerViewModel
): communicationBanner is TextBannerViewModel {
  return communicationBanner?.banner_type === 'text';
}

function isImageCommunicationBanner(
  communicationBanner: CommunicationBannerViewModel
): communicationBanner is ImageBannerViewModel {
  return communicationBanner?.banner_type === 'image';
}

export type CommunicationBannerProps = {
  communicationBanner: CommunicationBannerViewModel;
  showImageBanner: boolean;
};

export function CommunicationBanner({
  communicationBanner,
  showImageBanner,
}: CommunicationBannerProps) {
  const { pinning: manuallyPinning } = usePinStore();
  const isNavigatingAway = useIsNavigatingAway();
  const shouldShowSkeleton = manuallyPinning || isNavigatingAway;

  if (isTextCommunicationBanner(communicationBanner)) {
    if (shouldShowSkeleton) {
      return null;
    }
    return <TextBanner communicationBanner={communicationBanner} />;
  }
  if (isImageCommunicationBanner(communicationBanner) && showImageBanner) {
    if (shouldShowSkeleton) {
      return <CarouselSkeleton mode="image-banner" />;
    }
    return <ImageBanner communicationBanner={communicationBanner} />;
  }
  return null;
}
